export default "__VITE_ASSET__BDfWl23e__"